import { createAction } from 'redux-actions';

export const setContainerScrollTop = createAction(
  'SET_CONTAINER_SCROLL_TOP',
);